<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M21.972 17.403c-.084-.375-2.066-9.263-2.458-10.545C18.956 5.05 16.282 5 15.983 5a.835.835 0 0 0-.834.833c0 .458.375.833.834.833.707 0 1.807.25 1.94.683.109.358.375 1.433.692 2.807H9.743a.85.85 0 0 0-.633.225l-6.855 6.606a.823.823 0 0 0-.192.908.854.854 0 0 0 .775.524h8.247c.058 0 .116 0 .174-.016a.53.53 0 0 0 .15-.05c.475-.192 1.05-.592 1.775-1.1 1.532-1.066 3.806-2.632 6.38-3.007.292 1.3.575 2.557.792 3.515.083.392.433.65.808.65.058 0 .125 0 .183-.017a.83.83 0 0 0 .633-.99h-.008Zm-17.077-.65 4.282-4.123.866 4.123H4.895Zm7.33-.858c-.2.134-.39.275-.566.392l-.941-4.465h8.288c.058.267.125.533.183.8-2.898.458-5.314 2.124-6.955 3.273h-.008Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
